"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerBackground = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
const BannerBackground = _ref => {
  let {
    hasBackground,
    imageClassName,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: "cds-Teaser-DMKRoundedBackground-Wrapper"
  }, props), hasBackground && /*#__PURE__*/_react.default.createElement("figure", {
    className: "cds-Teaser-DMKRoundedBackground cds-Teaser-DMKRoundedBackground-Inner"
  }), hasBackground && /*#__PURE__*/_react.default.createElement("figure", {
    className: "cds-Teaser-DMKRoundedBackground cds-Teaser-DMKRoundedBackground-Outer"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(imageClassName, {
      'cds-Teaser-Image--Full': !hasBackground
    }),
    style: {
      backgroundImage: `url(${props.imageUrl})`
    }
  }));
};
exports.BannerBackground = BannerBackground;
//# sourceMappingURL=BannerBackground.js.map